module.exports = __webpack_public_path__ + "img/tag4.48e2cf55.png";